import React from 'react';
import './NavBar.css';
import {Navbar, Container, Nav} from 'react-bootstrap';
import logo from '../../images/logo.svg';

const NavBar = () => {
    return (
        <div>
            <Navbar expand="lg" className='fullNavBar'>
                <Container>
                    <Navbar.Brand href="#home">
                        <img src={logo} alt="" className='navLogo'/>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto NavBar">
                        <Nav.Link href="#services">Our Services</Nav.Link>
                        <Nav.Link href="#partner">Benefits</Nav.Link>
                        <Nav.Link href="#contact">Contact Us</Nav.Link>
                    </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default NavBar;